import { Component, HostListener } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { ApiService } from './services/api.service';
import { CommonService } from './services/common.service';
import { NgxSpinnerService } from 'ngx-spinner';
import { interval } from 'rxjs';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss']
})
export class AppComponent {
  //@HostListener("window:beforeunload", ["$event"])
  //clearLocalStorage(event) {
  //  localStorage.clear();
  //  sessionStorage.clear();
  //}
  title = 'KioskUI';
  textDir: string;
  constructor(
    private translate: TranslateService,
    private common: CommonService,
    private apiCall: ApiService,
    private Spinner: NgxSpinnerService
  ) { }
  ngOnInit(): void {

    this.translate.setDefaultLang('en');
    this.apiCall.startTokenCheck(); 
  }
  ngOnDestroy(): void {
    this.apiCall.stopTokenCheck();
  }
}
